import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import es from "./es.json";
import pt from "./pt.json";

/** Order matters: this is the order the language switcher renders them in. */
export const LANGUAGES = [
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "en", label: "English" },
] as const;

export type Language = (typeof LANGUAGES)[number]["code"];

export const STORAGE_KEY = "language";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
    supportedLngs: LANGUAGES.map((language) => language.code),
    // Argentine techs arrive as es-AR and Brazilian ones as pt-BR; we ship one
    // dictionary per language, not per region.
    load: "languageOnly",
    // Spanish, not English, is what an unrecognised locale falls back to: the
    // product is operated in the field in Argentina. English is the key space,
    // not the default audience.
    fallbackLng: "es",
    // Keys are whole English sentences. i18next otherwise reads "." as a key
    // path separator and ":" as a namespace separator, so "Status reported by
    // /api/health." would be looked up as a nested object and silently miss.
    keySeparator: false,
    nsSeparator: false,
    // React escapes for us; letting i18next escape again double-encodes.
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: STORAGE_KEY,
    },
  });

/**
 * The API answers errors and notices as English sentences. Translate the ones
 * the dictionaries know; anything else (a raw upstream error) shows as sent.
 */
export function translateServerText(text: string): string {
  return i18n.t(text as keyof typeof en);
}

export default i18n;
